import SimpleEvent from '../utils/simpleEvent';
var buildCommunicator = function () {
    var communicator = new UrlCommunicator();
    window.communicate = communicator.messageReceived.trigger;
    return communicator;
};
var UrlCommunicator = /** @class */ (function () {
    function UrlCommunicator() {
        this.buffer = [];
        this.messageReceived = new SimpleEvent();
        this.startSending();
    }
    UrlCommunicator.prototype.send = function (domain, type, data) {
        var urlBase = "liquidstate://" + domain + "/" + type;
        var serialised = encodeURIComponent(JSON.stringify(data));
        var url = urlBase + "?request=" + serialised;
        this.buffer.push(url);
    };
    UrlCommunicator.prototype.startSending = function () {
        var _this = this;
        setInterval(function () {
            if (_this.buffer.length) {
                var message = _this.buffer.shift();
                _this.doSend(message);
            }
        }, 100);
    };
    UrlCommunicator.prototype.doSend = function (url) {
        console.log('URL communicator, setting url: ' + url);
        document.location.href = url;
    };
    return UrlCommunicator;
}());
export { UrlCommunicator };
export default buildCommunicator;
//# sourceMappingURL=urlImpl.js.map